// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function removeEmptyFields<T extends Record<string, any>>(
  obj: T
): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([, value]) =>
        value !== 0 &&
        value?.length !== 0 &&
        value !== null &&
        value !== undefined
    )
  ) as Partial<T>;
}

type WithId = {
  _id?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

export function removeIdFromObjects<T extends WithId>(
  objects: T[]
): Omit<T, "_id">[] {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return objects.map(({ _id, ...rest }) => rest);
}

export function removeItemsWithIds(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  array: any[],
  idsToRemove: string[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any[] {
  return array.filter((item) => !item?._id || !idsToRemove.includes(item?._id));
}

export function createOptionsArray<T>(
  data: any,
  valueField: any,
  ...labelFields: any
) {
  return data?.map((item: any) => ({
    value: item[`${valueField}`] as string | number,
    label: labelFields
      ?.map((el: any) =>
        el.includes(".") ? item[el?.split(".")[0]][el?.split(".")[1]] : item[el]
      )
      ?.join(""),
  }));
}

// createOptionsArray(dataServices?.data, "_id", "name");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformToFormData(data: { [key: string]: any }): FormData {
  const formData = new FormData();

  for (const key in data) {
    if (data[key] instanceof File) {
      formData.append(key, data[key]);
    } else if (typeof data[key] === "string") {
      formData.append(key, data[key]);
    } else {
      // Handle nested objects or arrays if needed
      formData.append(key, JSON.stringify(data[key]));
    }
  }
  return formData;
}

interface DataObject {
  [key: string]: any;
}

export function convertToFormData(data: DataObject): FormData {
  const formData = new FormData();

  function appendFormData(key: string, value: any): void {
    if (value === undefined || value === null || value === "") {
      return;
    }

    if (value instanceof File) {
      formData.append(key, value, value.name);
    } else if (Array.isArray(value)) {
      if (value.length > 0) {
        value.forEach((item, index) => {
          appendFormData(`${key}[${index}]`, item);
        });
      }
    } else if (typeof value === "object" && value !== null) {
      Object.keys(value).forEach((subKey) => {
        appendFormData(`${key}[${subKey}]`, value[subKey]);
      });
    } else {
      formData.append(key, value);
    }
  }

  Object.keys(data).forEach((key) => {
    appendFormData(key, data[key]);
  });

  return formData;
}
// const convertToFormData = (obj: any, form?: FormData, namespace?: string): FormData => {
//   let formData = form || new FormData();

//   for (let property in obj) {
//     if (obj.hasOwnProperty(property)) {
//       let formKey = namespace ? `${namespace}[${property}]` : property;

//       if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
//         convertToFormData(obj[property], formData, formKey);
//       } else {
//         formData.append(formKey, obj[property] === undefined ? '' : obj[property]);
//       }
//     }
//   }

//   return formData;
// };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getArrayKeys(obj: any) {
  const result = [];
  for (const key in obj) {
    if (Array.isArray(obj[key])) {
      result.push({ [key]: obj[key] });
    }
  }
  return result;
}

type Permission = {
  [key: string]: string[];
};

export function comparePermissionLists(
  list1: Permission[],
  list2: Permission[]
): boolean {
  if (list1.length !== list2.length) {
    return false;
  }

  for (let i = 0; i < list1.length; i++) {
    const keys1 = Object.keys(list1[i]);
    const keys2 = Object.keys(list2[i]);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!keys2.includes(key)) {
        return false;
      }

      const values1 = list1[i][key];
      const values2 = list2[i][key];

      if (values1.length !== values2.length) {
        return false;
      }

      for (const value of values1) {
        if (!values2.includes(value)) {
          return false;
        }
      }
    }
  }

  return true;
}

// const methodsOrder = ["POST", "GET", "PATCH", "DELETE", "DATA"];

// export const toggleAndSortMethod = (method: string, methodArray: string[]) => {
//   const index = methodArray.indexOf(method);
//   if (index === -1) {
//     // Method not found, add it
//     methodArray.push(method);
//   } else {
//     // Method found, remove it
//     methodArray.splice(index, 1);
//   }
//   // Sort the array based on the defined order
//   methodArray.sort((a, b) => methodsOrder.indexOf(a) - methodsOrder.indexOf(b));
//   return methodArray;
// };
